export default "__VITE_ASSET__Ble4VRkQ__"